import { render, staticRenderFns } from "./EmojiStats.vue?vue&type=template&id=aba9c968&"
import script from "./EmojiStats.vue?vue&type=script&lang=js&"
export * from "./EmojiStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports